import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

function DrawerBody({ children, sx, ...props }) {
	return (
		<Box
			{...props}
			sx={{
				px: 3,
				flex: 1,
				minHeight: 0,
				boxSizing: 'border-box',
				display: 'flex',
				flexDirection: 'column',
				scrollbarGutter: 'stable',
				overflowY: 'auto',
				overflowX: 'hidden',
				...sx,
			}}
		>
			{children}
		</Box>
	);
}

DrawerBody.propTypes = {
	children: PropTypes.node,
	sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default React.memo(DrawerBody);
